import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: resolve => require(['../views/Home'], resolve),
      children: []
    },
    {
      path: '/report',
      name: 'report',
      component: resolve => require(['../views/Report'], resolve),
      children: []
    },
    {
      path: '*',
      redirect: '/home',
    },
  ],
})


router.beforeEach((to, from, next) => {
  console.log(to);
  if (to.query.lang) {
    Vue.prototype.$setLang(to.query.lang)
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js